import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook } from "lucide-react";
import { Header } from "../components/Header";
import { ContactFooter } from "../components/ContactFooter";
import { AssistantWidget } from "../components/AssistantWidget";
import { useLanguage } from "../i18n";

const EMAIL = "info.farlight.official@gmail.com";

export default function ContactSupportPage() {
  const { t } = useLanguage();
  // The same email and social links the footer form already shows, as a row of contact options
  const OPTIONS = [
    { id: "email", Icon: Mail, label: t.contact.emailLabel, value: EMAIL, href: `mailto:${EMAIL}` },
    { id: "instagram", Icon: Instagram, label: t.legal.instagram, value: "@farlight_official", href: "https://www.instagram.com/farlight_official/", external: true },
    { id: "facebook", Icon: Facebook, label: "Facebook", value: "FArLight", href: "https://www.facebook.com/share/1JTT8Mr7xU/?mibextid=wwXIf", external: true },
  ];
  return (
    <div data-testid="contact-support-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <section data-testid="contact-support-heading" className="mt-14 pt-14 lg:pt-16 bg-sand">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-inksoft">
              <Link to="/" className="hover:text-ink">Home</Link> · {t.nav.contactSupport}
            </p>
            <h1 data-testid="contact-support-title" className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">{t.contactPage.title}</h1>
            <p data-testid="contact-support-intro" className="mt-5 max-w-2xl text-base lg:text-lg leading-relaxed text-inksoft">{t.contactPage.intro}</p>
          </div>
        </section>
        <section data-testid="contact-options" className="pt-10 pb-16 lg:pb-20 bg-sand">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr] gap-4 lg:gap-6">
            {OPTIONS.map(({ id, Icon, label, value, href, external }) => (
              <a
                key={id}
                data-testid={`contact-option-${id}`}
                href={href}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="group flex items-center gap-5 bg-white border border-ink/10 rounded-sm p-6 shadow-[0_8px_30px_rgba(42,39,38,0.04)] transition-all hover:-translate-y-0.5 hover:border-[#C5A059]"
              >
                <span className="shrink-0 inline-flex w-12 h-12 items-center justify-center rounded-full border border-[#C5A059] text-[#C5A059] transition-colors group-hover:bg-[#C5A059] group-hover:text-white">
                  <Icon className="w-5 h-5" strokeWidth={1.5} />
                </span>
                <span className="min-w-0">
                  <span className="block font-mono text-[11px] uppercase tracking-[0.15em] text-inksoft">{label}</span>
                  <span className="mt-1 block text-base text-ink break-words">{value}</span>
                </span>
              </a>
            ))}
          </div>
        </section>
      </main>
      <ContactFooter clearWidget showContactLinks={false} />
      <AssistantWidget />
    </div>
  );
}
